import { createWorkspaceRepository } from '../infrastructure/storage/legacy-workspace-reader.js'
import { createWorkspaceService } from '../domains/workspace/workspace-service.js'
import { createCanvasStore } from '../domains/canvas/canvas-reducer.js'
import { GenerationScheduler } from '../domains/generation/scheduler.js'
import { createOutputRepository } from '../infrastructure/storage/output-repository.js'
import { createLegacyDataRepository } from '../infrastructure/storage/legacy-data-repository.js'
import { createBackupRepository } from '../infrastructure/storage/backup-repository.js'
import { createImageRepository } from '../infrastructure/storage/image-repository.js'

export function createDependencies({ storage = globalThis.localStorage, provider } = {}) {
  const workspaceRepository = createWorkspaceRepository({ storage })
  const workspaceService = createWorkspaceService(workspaceRepository)
  const loaded = workspaceService.load()
  const active = workspaceService.active()
  const canvasStore = createCanvasStore(active)
  const scheduler = new GenerationScheduler({ concurrency: 4 })
  const outputRepository = createOutputRepository({ storage })
  const dataRepository = createLegacyDataRepository({ storage })
  const imageRepository = createImageRepository()
  const backupRepository = createBackupRepository({ workspaceRepository, dataRepository, imageRepository })
  return { workspaceRepository, workspaceService, canvasStore, scheduler, outputRepository, dataRepository, imageRepository, backupRepository, provider, loadResult: loaded }
}
